import React, { useEffect, useState } from 'react';
import {
  Box, TextField, Typography, Button, Avatar, Checkbox, FormControlLabel, Grid, MenuItem
} from '@mui/material';
import servicio1 from '../../../services/servicio1';
import Navbar from '../navcomun';
import fondoCancha from '../../../Assets/fondo-cancha.jpg'; // Asegurate que la ruta esté bien

export default function PerfilJugador() {
  const [jugador, setJugador] = useState(null);
  const [editando, setEditando] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchJugador = async () => {
      try {
        const loggedUserJSON = window.localStorage.getItem('loggedNoteAppUser');
        if (loggedUserJSON) {
          const userData = JSON.parse(loggedUserJSON);
          const data = await servicio1.traerJugador({ id_usuario: userData?.id });
          setFormData({ id: userData?.id });
          setJugador(data[0]);
          //setFormData(data[0]);
          let diasDisponibles = data[0].dias_disponibles;

          if (typeof diasDisponibles === 'string') {
            try {
              diasDisponibles = JSON.parse(diasDisponibles);
              if (!Array.isArray(diasDisponibles)) diasDisponibles = [];
            } catch {
              diasDisponibles = [];
            }
          }

          setFormData({
            ...data[0],
            dias_disponibles: diasDisponibles
          });
        }
      } catch (error) {
        console.error('Error al traer perfil:', error);
      }
    };

    fetchJugador();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const booleanFields = ['es_pago', 'no_pago_cancha', 'cobro_por_sumarme', 'me_sumo_disponible'];

    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox'
        ? (booleanFields.includes(name) ? (checked ? 'Si' : 'No') : checked)
        : value
    }));
  };


const handleSave = async () => {
  try {
    const datosAEnviar = {
      ...formData,
      dias_disponibles: Array.isArray(formData.dias_disponibles) && formData.dias_disponibles.length > 0
        ? formData.dias_disponibles
        : [], // O "Sin definir" si tu backend lo requiere así
    };

    await servicio1.modificarJugador(datosAEnviar);
    setJugador(datosAEnviar);
    setEditando(false);
  } catch (error) {
    console.error('Error al guardar perfil:', error);
  }
};


  if (!jugador) return <Typography sx={{ p: 3 }}>Cargando perfil...</Typography>;

  return (
    <>
      <Navbar />
      <Box
        sx={{
          backgroundImage: `url(${fondoCancha})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          p: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.92)',
            borderRadius: 3,
            maxWidth: 800,
            mx: 'auto',
            p: 3,
            boxShadow: 4,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <Avatar src={jugador.foto_perfil} sx={{ width: 70, height: 70, mr: 2 }} />
            <Typography variant="h5">{jugador.nombre} ({jugador.apodo})</Typography>
          </Box>

          <Button variant="contained" onClick={() => setEditando(!editando)} sx={{ mb: 2 }}>
            {editando ? 'Cancelar' : 'Editar perfil'}
          </Button>

          {editando ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Nombre" name="nombre" value={formData.nombre || ''} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Apodo" name="apodo" value={formData.apodo || ''} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Teléfono" name="tel" value={formData.tel || ''} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Barrio" name="barrio" value={formData.barrio || ''} onChange={handleChange} />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox name="es_pago" checked={formData.es_pago === 'Si'} onChange={handleChange} />
                  }
                  label="Jugador pago"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="no_pago_cancha"
                      checked={formData.no_pago_cancha === 'Si'}
                      onChange={handleChange}
                    />
                  }
                  label="No pago la cancha"
                />
              </Grid>

              {/* <Grid item xs={12}>
  <FormControlLabel
    control={
      <Checkbox
        name="cobro_por_sumarme"
        checked={formData.cobro_por_sumarme === 'Sí'}
        onChange={handleChange}
      />
    }
    label="¿Me cobran por sumarme?"
  />
</Grid> */}

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="me_sumo_disponible"
                      checked={formData.me_sumo_disponible === 'Si'}
                      onChange={handleChange}
                    />
                  }
                  label="Si estoy disponible me sumo"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1">Días disponibles</Typography>
                <Grid container spacing={1}>
                  {['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'].map(dia => (
                    <Grid item xs={6} sm={4} key={dia}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.dias_disponibles?.includes(dia)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setFormData(prev => ({
                                ...prev,
                                dias_disponibles: checked
                                  ? [...(prev.dias_disponibles || []), dia]
                                  : (prev.dias_disponibles || []).filter(d => d !== dia)
                              }));
                            }}
                          />
                        }
                        label={dia}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
 <Grid item xs={12}>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Horarios disponibles"
                  name="horarios_disponibles"
                  value={formData.horarios_disponibles || ''}
                  onChange={handleChange}
                >
                  {['Mañana', 'Tarde', 'Noche'].map(h => (
                    <MenuItem key={h} value={h}>{h}</MenuItem>
                  ))}
                </TextField>
              </Grid></Grid><br/>

        <Grid item xs={12}>
  <Box
    sx={{
      mt: 4,
      p: 2,
      textAlign: 'center',
      borderTop: '1px solid #ccc',
      backgroundColor: '#f5f5f5',
      borderRadius: '0 0 16px 16px',
    }}
  >
    <Button variant="contained" color="success" onClick={handleSave}>
      Guardar cambios
    </Button>
  </Box>
</Grid>
            </Grid>
          ) : (
            <Box>
              <Typography><strong>Teléfono:</strong> {jugador.tel}</Typography>
              <Typography><strong>Barrio:</strong> {jugador.barrio}</Typography>
              <Typography><strong>Es pago:</strong> {jugador.es_pago ? 'Si' : 'No'}</Typography>
              <Typography><strong>Días disponibles:</strong> {jugador.dias_disponibles}</Typography>
              <Typography><strong>Horarios disponibles:</strong> {jugador.horarios_disponibles}</Typography>
              <Typography><strong>No pago la cancha:</strong> {jugador.no_pago_cancha}</Typography>
              <Typography><strong>Cobro por sumarme:</strong> {jugador.es_pago}</Typography>
              <Typography><strong>Disponible para sumarme:</strong> {jugador.me_sumo_disponible}</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}
